import ActionConfirmModal from "./action-confirm-modal";

/**
 * §Escalate-overdue: the one confirm step for escalating, shared by all three surfaces that offer it
 * (the tasks dashboard, the step card, the leads kanban).
 *
 * It always NAMES the step. That is load-bearing on the kanban, where a card shows the case's current-step
 * deadline but carries the agent-queue task for a possibly DIFFERENT step — without the name, "is overdue"
 * would not tell the agent which step they are about to raise. The other two surfaces get the same sentence
 * for free, and the copy cannot drift between them.
 *
 * The note is required here rather than by the endpoint: an escalation with no reason gives the manager
 * receiving it nothing to act on.
 */
const EscalateConfirmModal = ({
  stepName,
  stepUid,
  caseUid,
  busy,
  onCancel,
  onConfirm,
}: {
  /** null ⇒ closed. The step being escalated, named in the message. */
  stepName: string | null;
  stepUid: string | null;
  caseUid: string | null;
  busy: boolean;
  onCancel: () => void;
  /** Called only with a non-empty, trimmed note. */
  onConfirm: (note: string, attachmentUids?: string[]) => void | Promise<unknown>;
}) => (
  <ActionConfirmModal
    request={
      stepName
        ? {
            title: "Escalate task",
            message: `"${stepName}" is overdue. Escalating records it on the step and alerts the escalation contacts configured for it — the assignee is not changed.`,
            commentRequired: true,
            commentLabel: "Escalation note",
            confirmLabel: "Escalate",
            destructive: true,
          }
        : null
    }
    busy={busy}
    caseUid={caseUid}
    attachmentContext={
      caseUid && stepUid ? {kind: "escalation", stepUid} : null
    }
    onCancel={onCancel}
    onConfirm={(note, attachmentUids) => {
      const trimmed = note?.trim();
      if (trimmed) return onConfirm(trimmed, attachmentUids);
    }}
  />
);

export default EscalateConfirmModal;
